export const formatCuit = (cuit: string | null | undefined): string | null => {
    if (!cuit) return null;
    const d = cuit.replace(/\D/g, "");
    if (d.length === 11) return `${d.slice(0, 2)}-${d.slice(2, 10)}-${d.slice(10)}`;
    return cuit;
};

export const formatAddress = (
    street: string | null | undefined,
    num: string | null | undefined,
    floor: string | null | undefined,
    locality: string | null | undefined,
    cp: string | null | undefined,
): string | null => {
    if (!street) return null;
    let addr = street;
    if (num) addr += ` ${num}`;
    if (floor) addr += `, ${floor}`;
    if (locality || cp)
        addr += ` — ${[locality, cp ? `CP ${cp}` : null].filter(Boolean).join(", ")}`;
    return addr;
};

export const formatPhoneDisplay = (
    areaCode: string | null | undefined,
    phone: string | null | undefined,
): string => [areaCode, phone].filter(Boolean).join(" ");
